import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Papa from 'papaparse';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import FilterPannel from '../filter/FilterPannel';
import moment from 'moment';
import LeadAPI from '../../api/LeadAPI';

class FixedLeadReport extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model);
    this.lead = this.model.lead;
    this.users = this.model.user.options;
    this.progress = this.model.lead.fields.progress.options;

    this.area = reactLocalStorage.getObject(Const.Areas) ?? [];    
    this.property_type = this.model.property.fields.property_type?.options ?? [];    
    this.property_transaction = this.model.property.fields.property_transaction?.options ?? [];    
    this.property_is = this.model.property.fields.type?.options ?? [];    
    this.occupation = this.model.lead.fields.occupation?.options ?? [];    
    this.furnishing = this.model.property.fields.furnishing?.options ?? [];    

    this.source = this.model.source.options;
    this.city = reactLocalStorage.getObject(Const.Cities);
    this.states = reactLocalStorage.getObject(Const.States);
    this.country = reactLocalStorage.getObject(Const.Countries);
    this.callFeedback = this.model.call.fields.feedback.options;
    this.meetingFeedback = this.model.meeting.fields.feedback.options;
    this.gender = this.model.lead.fields.gender.options;
    this.leadState = this.model.lead.fields.lead_state.options;
    this.filters = [];
    this.state = {
      inApiCall: false,
      isFilterOpen: true,
    };
  }

  handleCsv = async () => {
    this.setState({ inApiCall: true });
    LeadAPI.getFixedLeadReportList(this.filters, this.onReceived, this.onFail);
  };

  onReceived = (response) => {
    try {
      if (response && Array.isArray(response)) {
        response.forEach((obj) => {
          Object.keys(obj).forEach(key => {
            // if (typeof obj[key] === 'string' && obj[key].indexOf(Const.Opt) !== -1) {
            //   obj[key] = obj[key].split(Const.Opt).join('');
            // }
            if (obj[key] === null || obj[key] === '~~' || obj[key] === '' || obj[key] === 'undefined' || obj[key] === 0) {
              obj[key] = '-';
            }
          });
          obj.description = obj.description.split('<p>').join('').split('</p>').join('');
          obj.progress = this.progress.find((pro) => pro.value === obj?.progress)?.label;
          
          obj.area =  obj.area.split(Const.Opt).filter(Boolean).map((id) => this.area.find((pro) => parseInt(pro.value) === parseInt(id))?.label).join(", ");
          obj.property_type = obj.property_type.split(Const.Opt).filter(Boolean).map((id) => this.property_type.find((pro) => parseInt(pro.value) === parseInt(id))?.label).join(", ");
          obj.property_transaction = obj.property_transaction.split(Const.Opt).filter(Boolean).map((id) => this.property_transaction.find((pro) => parseInt(pro.value) === parseInt(id))?.label).join(", ");
          obj.property_is = obj.property_is.split(Const.Opt).filter(Boolean).map(id => this.property_is.find((pro) => parseInt(pro.value) === parseInt(id))?.label).join(', ');
          obj.occupation = obj.occupation.split(Const.Opt).filter(Boolean).map(id => this.occupation.find((pro) => parseInt(pro.value) === parseInt(id))?.label).join(", ");
          obj.furnishing = obj.furnishing.split(Const.Opt).filter(Boolean).map(id => this.furnishing.find((pro) => parseInt(pro.value) === parseInt(id))?.label)?.join(", ");

          obj.gender = this.gender.find((pro) => pro.value === parseInt(obj.gender))?.label;
          obj.lead_state = this.leadState.find((pro) => pro.value === obj?.lead_state)?.label;
          obj.source = this.source.find((pro) => pro.value === obj?.source)?.label;
          obj.responsible_person = obj.responsible_person && obj.responsible_person.split(Const.Opt).filter(Boolean).map((id) => this.users.find((pro) => pro.value === parseInt(id))?.name).join(', ');
          obj.address_city = obj.address_city.split(Const.Opt).filter(Boolean).map((id) => this.city.find((pro) => pro.value === parseInt(id))?.label).join(', ');
          obj.address_state = obj.address_state.split(Const.Opt).filter(Boolean).map((id) => this.states.find((pro) => pro.value === parseInt(id))?.label).join(', ');
          obj.address_country = obj.address_country.split(Const.Opt).filter(Boolean).map((id) => this.country.find((pro) => pro.value === parseInt(id))?.label).join(', ');
          obj.last_call_feedback = this.callFeedback.find((pro) => pro.value === obj?.last_call_feedback)?.label;
          obj.last_meeting_feedback = this.meetingFeedback.find((pro) => pro.value === obj?.last_meeting_feedback)?.label;
          obj.dob = obj.dob.split('T')[0];
          obj.enquiry_date = moment(obj.enquiry_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.created_date = moment(obj.created_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.updated_date = moment(obj.updated_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.next_meeting_date = obj?.next_meeting_date === '-' ? '-' : moment(obj.next_meeting_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.last_meeting_date = obj?.last_meeting_date === '-' ? '-' : moment(obj.last_meeting_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.last_call_date = obj?.last_call_date === '-' ? '-' : moment(obj.last_call_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.next_call_date = obj?.next_call_date === '-' ? '-' : moment(obj.next_call_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.created_by = this.users.find((pro) => pro.value === obj.created_by)?.name;
          obj.updated_by = this.users.find((pro) => pro.value === obj.updated_by)?.name;
          Object.keys(obj).forEach(key => {
            if (key.includes('custom')) {
              const leadField = this.lead.fields[key];
              if (leadField && leadField.options) {
                obj[key] = leadField.options.find(option => option.value === obj[key])?.label || obj[key];
              }
            }
          });
        });
        response.map((obj) => Object.keys(obj).forEach(key => {
          if (this.lead.fields[key]) {
            obj[this.lead.fields[key].label_name] = obj[key];
            delete obj[key];
          }
        }));
        return this.generateCSV(response);
      } else {
        throw new Error("Invalid data format from API");
      }
    } catch (error) {
      console.log({error});
      this.onFail(error);
    }
  };
  generateCSV = (data) => {
    try {
      const csv = Papa.unparse(data, { header: true });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'LeadReport.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Util.showNotification('Successful', 'Lead Report Downloaded successfully', 'success');

    } catch (error) {
      console.error("Error generating CSV:", error);
      Util.showError("Failed to generate CSV file");
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  onFail = (error) => {
    this.setState({ inApiCall: false });
    console.error("API call failed:", error);
    Util.showError("Something Went Wrong");
  };

  toggleFilter = () => {
    this.setState((prevState) => ({ isFilterOpen: !prevState.isFilterOpen }));
  };

  closeFilter = () => {
    this.setState({ isFilterOpen: false });
  };

  onFilterChange = (filters) => {
    this.filters = filters;
    Util.showNotification('Successful', 'Filter Applied successfully', 'success');
  };

  render() {
    if (!this.lead || !this.lead.fields) return null;

    return (
      <div style={{ padding: '20px', backgroundColor: '#f9f9f9', textAlign: 'center' }}>
        {/* Heading and Buttons in One Line */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px', position: 'relative' }}>
          <h1 style={{ margin: '0', color: '#333' }}>Lead Report</h1>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
            {/* Filter Button */}
            {/* <button 
            onClick={this.toggleFilter} 
            disabled={this.state.inApiCall}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 20px',
              border: '1px solid #007bff',
              backgroundColor: '#ffffff',
              color: '#007bff',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            <FaFilter style={{ marginRight: '8px' }} />
            {this.state.isFilterOpen ? 'Close Filter' : 'Filter'}
          </button> */}

            {/* Download CSV Button */}
            <button
              onClick={this.handleCsv}
              disabled={!this.filters}
              style={{
                padding: '10px 20px',
                backgroundColor: this.state.inApiCall ? '#cccccc' : '#28a745',
                color: '#ffffff',
                border: 'none',
                cursor: this.state.inApiCall ? 'not-allowed' : 'pointer',
                fontSize: '14px',
              }}
            >
              {this.state.inApiCall ? 'Preparing CSV...' : 'Download Report'}
            </button>
          </div>
        </div>

        {/* Filter Panel */}
        {this.state.isFilterOpen && (
          <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }}>
            <FilterPannel
              filters={this.filters}
              fields={this.lead.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FixedLeadReport;
